import OrganizationService from "@/services/OrganizationService.js";

export default {
    namespaced: true,
    state: {
        isLoading: false,
        errors: null,
        branchDetails: {
            "deliver_now":{
              "name":"Deliver Now",
              "enable":true
            },
            "scheduled_delivery":{
              "name":"Scheduled Delivery",
              "enable":true
            },
            "pickup_now":{
              "name":"Pickup Now",
              "enable":true
            },
            "scheduled_pickup":{
              "name":"Scheduled Pickup",
              "enable":true
            },
            "is_open":true,
            "orders_allowable":true,
            "server_time":"2022-12-07 09:37:47",
            "store_hours":[
              {
                "day":"monday",
                "hide":false,
                "closing":"06:30",
                "opening":"07:00",
                "cut_off_time":null,
                "temporary_closed":false
              },
              {
                "day":"tuesday",
                "hide":false,
                "closing":"23:00",
                "opening":"07:00",
                "cut_off_time":null,
                "temporary_closed":false
              },
              {
                "day":"wednesday",
                "hide":false,
                "closing":"23:00",
                "opening":"07:00",
                "cut_off_time":null,
                "temporary_closed":false
              },
              {
                "day":"thursday",
                "hide":false,
                "closing":"23:59",
                "opening":"08:00",
                "cut_off_time":null,
                "temporary_closed":false
              },
              {
                "day":"friday",
                "hide":false,
                "closing":"23:59",
                "opening":"08:00",
                "cut_off_time":null,
                "temporary_closed":false
              },
              {
                "day":"saturday",
                "hide":false,
                "closing":"23:56",
                "opening":"09:00",
                "cut_off_time":"23:01",
                "temporary_closed":false
              },
              {
                "day":"sunday",
                "hide":false,
                "closing":"23:59",
                "opening":"08:00"
              }
            ],
            "delivery_settings":{
              "minimum_lead_time_value":30,
              "minimum_lead_time":"minutes",
              "duration_lead_time_value":13,
              "duration_lead_time":"days",
              "schedule_type":"days_only",
              "pre_order_schedules":{
                "friday":{
                  "end":"16:00",
                  "start":"08:00",
                  "enable":true
                },
                "monday":{
                  "end":"23:30",
                  "start":"07:00",
                  "enable":true
                },
                "sunday":{
                  "end":"23:59",
                  "start":"08:00",
                  "enable":true
                },
                "tuesday":{
                  "end":"23:59",
                  "start":"00:01",
                  "enable":true
                },
                "saturday":{
                  "end":"22:00",
                  "start":"09:00",
                  "enable":true
                },
                "thursday":{
                  "end":"23:59",
                  "start":"08:00",
                  "enable":true
                },
                "wednesday":{
                  "end":"21:30",
                  "start":"09:00",
                  "enable":false
                }
              },
              "initial_dates":[
                {
                  "date":"2022-12-07",
                  "remaining_orders_accepted":30
                },
                {
                  "date":"2022-12-08",
                  "remaining_orders_accepted":30
                },
                {
                  "date":"2022-12-09",
                  "remaining_orders_accepted":30
                },
                {
                  "date":"2022-12-10",
                  "remaining_orders_accepted":30
                },
                {
                  "date":"2022-12-11",
                  "remaining_orders_accepted":30
                },
                {
                  "date":"2022-12-12",
                  "remaining_orders_accepted":30
                },
                {
                  "date":"2022-12-13",
                  "remaining_orders_accepted":30
                },
                {
                  "date":"2022-12-14",
                  "remaining_orders_accepted":30
                },
                {
                  "date":"2022-12-15",
                  "remaining_orders_accepted":30
                },
                {
                  "date":"2022-12-16",
                  "remaining_orders_accepted":30
                },
                {
                  "date":"2022-12-17",
                  "remaining_orders_accepted":30
                },
                {
                  "date":"2022-12-18",
                  "remaining_orders_accepted":30
                },
                {
                  "date":"2022-12-19",
                  "remaining_orders_accepted":30
                }
              ]
            },
            "pickup_settings":{
              "minimum_lead_time_value":60,
              "minimum_lead_time":"minutes",
              "duration_lead_time_value":13,
              "duration_lead_time":"days",
              "schedule_type":"days_only",
              "pre_order_schedules":{
                "friday":{
                  "end":"16:00",
                  "start":"08:00",
                  "enable":true
                },
                "monday":{
                  "end":"23:30",
                  "start":"07:00",
                  "enable":true
                },
                "sunday":{
                  "end":"23:59",
                  "start":"08:00",
                  "enable":true
                },
                "tuesday":{
                  "end":"23:59",
                  "start":"00:01",
                  "enable":true
                },
                "saturday":{
                  "end":"22:00",
                  "start":"09:00",
                  "enable":true
                },
                "thursday":{
                  "end":"23:59",
                  "start":"08:00",
                  "enable":true
                },
                "wednesday":{
                  "end":"21:30",
                  "start":"09:00",
                  "enable":false
                }
              },
              "initial_dates":[
                {
                  "date":"2022-12-07",
                  "remaining_orders_accepted":30
                },
                {
                  "date":"2022-12-08",
                  "remaining_orders_accepted":30
                },
                {
                  "date":"2022-12-09",
                  "remaining_orders_accepted":30
                },
                {
                  "date":"2022-12-10",
                  "remaining_orders_accepted":30
                },
                {
                  "date":"2022-12-11",
                  "remaining_orders_accepted":30
                },
                {
                  "date":"2022-12-12",
                  "remaining_orders_accepted":30
                },
                {
                  "date":"2022-12-13",
                  "remaining_orders_accepted":30
                },
                {
                  "date":"2022-12-14",
                  "remaining_orders_accepted":30
                },
                {
                  "date":"2022-12-15",
                  "remaining_orders_accepted":30
                },
                {
                  "date":"2022-12-16",
                  "remaining_orders_accepted":30
                },
                {
                  "date":"2022-12-17",
                  "remaining_orders_accepted":30
                },
                {
                  "date":"2022-12-18",
                  "remaining_orders_accepted":30
                },
                {
                  "date":"2022-12-19",
                  "remaining_orders_accepted":30
                }
              ]
            },
            "status":200,
            "messaged":"Retrieved branch details."
        }
    },
    mutations: {
        setIsLoading(state, payload) {
            state.isLoading = payload;
        },
        setErrors(state, payload) {
            state.errors = payload;
        },
        setBranchDetails(state, payload) {
            state.branchDetails = payload;
        }
    },
    actions: {
        async getBranchDetails({ commit }, request) {
            commit("setIsLoading", true);

            try {
                commit("setBranchDetails",
                    await OrganizationService.getBranchDetails(request)
                );
            } catch (errors) {
                commit("setErrors", errors);
            } finally {
                commit("setIsLoading", false);
            }
        }
    }
};
